import * as React from "react";
import './FormBusiness.css'
import FormStepper from "../../../components/FormStepper/FormStepper";
import {InputTypes} from "../../../components/FormStepper/InputTypes";
import FormButton from "../../../../../components/FormButton/FormButton";

import {observer} from "mobx-react";
import {FormComponent} from "../../../state/FormsState";
import FormUtils from "../../../FormUtils";
import ResetFormBtn from "../../../../../components/ResetForm/resetFormBtn";
import GoogleAnalyticsService from "../../../../../services/Analytics/GoogleAnalyticsService";
import MixPanelAnalyticsService from "../../../../../services/Analytics/MixPanelAnalyticsService";
import {AnalyticsSignUpEvents} from "../../../../../services/Analytics/AnalyticsSignUpEvents";
import FBPixelService from "../../../../../services/Analytics/FBPixelService";
import {LeadPlanType} from "shared/functions/membersApi/types/ISignupProcess";
import {RouteComponentProps} from "react-router";
import NavigationConstants from "../../../../Navigation/NavigationConstants";
import {ESBABusinessType} from "shared/model/IApplication";

interface IProps extends RouteComponentProps<any> {
    store: any
}

interface ILocalState {
    navigateToLogin: boolean
}
const storePropertyName = 'business';

const FORM_BUSINESS_PAGE_TEXTS = {
    titles: {
        HEADER: "Business",
        FULL_NAME: "Your full name",
        EMAIL_ADDRESS: "Work email address",
        BUSINESS_NAME: "Business legal name",
        BUSINESS_TYPE: "Please select a business type",
        CELL_PHONE_NUMBER: "Cell Phone number",
        BUSINESS_PHONE_SUB_HEADER:"Required for non-commercial, time-sensitive notifications about your application. We will never sell your data to anyone.",
        ADDRESS: "Residential address"
    },
    placeHolders: {
        GENERAL: "Write here...",
        CELL_PHONE_NUMBER: "(123) 456–7890",
        ADDRESS: "3 W 23rd St, New York, NY 10010",
        BUSINESS_TYPE: "Choose your answer"
    },
    propertyNames: {
        FULL_NAME: "fullName",
        EMAIL_ADDRESS: "userEmail",
        BUSINESS_NAME: "userCompanyName",
        CELL_PHONE_NUMBER: "userCellPhone",
        ADDRESS: "userAddress",
        BUSINESS_TYPE: "businessType"
    }
};

@observer
export default class FormBusiness  extends React.Component<IProps> {

    public state: ILocalState = {
        navigateToLogin: false
    }

    public componentDidMount = () => {
        FormUtils.setFormNavigationOnInit(storePropertyName, this.props.store);
        GoogleAnalyticsService.virtualPageView("business-details");
    };

    public getFormStatus = () => {
        const {store} = this.props;
        const businessFormInput = store.formInput.business;
        if(!businessFormInput) {
            return false;
        }
        const businessSteps = this.getBusinessPageSteps();
        let result = true;
        for (const [key] of Object.entries(businessFormInput)) {
            const currentStepValues = businessSteps.filter((step: any) => step.propName ===  key);
            result = Boolean(FormUtils.validateInput(currentStepValues[0].inputType, businessFormInput[key]) && result);
        }
        return result
    };

    public renderNextButton = () => {
        const {store} = this.props;
        const classes = this.getFormStatus() && store.isEmailValid? "blue" : "disabled";
        return <FormButton click={this.navigateForward} btnText={'Next'} classes={classes}/>
    };

    public navigateForward = () => {
        const {store} = this.props;
        if(!store.isEmailValid) {
            return;
        }
        if(this.getFormStatus()) {
            this.trackAnalytics();
            store.updateBusinessStage();
            store.updateCurrentComponent(FormComponent.financial);
        }
    };

    public renderFormStepper = () => {
        const {store} = this.props;
        return <FormStepper steps={this.getBusinessPageSteps()} store={store} navigationProperty={storePropertyName}/>
    };

    public renderPageNavigation = () =>  {
        const {store} = this.props;
        return (
            <div className= {"form-navigation" + (!store.showResetFormButton? " align-right": "")}>
                {store.showResetFormButton? <ResetFormBtn/>: null}
                <div className="link-next">{this.renderNextButton()}</div>
            </div>
        )
    };

    public render() {
        return (
            <>
                {this.renderLoginLinkIfNeeded()}
                {this.renderFormStepper()}
                {/*{this.renderCreateUserErrorIfNeeded()}*/}
                {this.renderPageNavigation()}
            </>
        );
    };

    private getBusinessPageSteps = () => {
        const {store} = this.props;
        const businessSteps: any = [
            {
                isHeader: true,
                title: FORM_BUSINESS_PAGE_TEXTS.titles.HEADER,
                inputType: InputTypes.none
            },
            {
                title: FORM_BUSINESS_PAGE_TEXTS.titles.FULL_NAME,
                inputPlaceHolder: FORM_BUSINESS_PAGE_TEXTS.placeHolders.GENERAL,
                inputType: InputTypes.text,
                propName: FORM_BUSINESS_PAGE_TEXTS.propertyNames.FULL_NAME
            },
            {
                title: FORM_BUSINESS_PAGE_TEXTS.titles.EMAIL_ADDRESS,
                inputPlaceHolder: FORM_BUSINESS_PAGE_TEXTS.placeHolders.GENERAL,
                inputType: InputTypes.email,
                propName: FORM_BUSINESS_PAGE_TEXTS.propertyNames.EMAIL_ADDRESS,
                customValidationCheck: FormUtils.validateEmailChars,
                errorLabel: this.getEmailErrorMessage()
            },
            {
                title: FORM_BUSINESS_PAGE_TEXTS.titles.BUSINESS_NAME,
                inputPlaceHolder: FORM_BUSINESS_PAGE_TEXTS.placeHolders.GENERAL,
                inputType: InputTypes.text,
                propName: FORM_BUSINESS_PAGE_TEXTS.propertyNames.BUSINESS_NAME
            }
        ];
        if(store.formInput.plans.plansValue === LeadPlanType.Loan) {
            businessSteps.push({
                title: FORM_BUSINESS_PAGE_TEXTS.titles.BUSINESS_TYPE,
                propName: FORM_BUSINESS_PAGE_TEXTS.propertyNames.BUSINESS_TYPE,
                inputPlaceHolder: FORM_BUSINESS_PAGE_TEXTS.placeHolders.BUSINESS_TYPE,
                options: this.generateCompanyTypes(),
                cb: this.updateSelectedBusinessType,
                inputType: InputTypes.dropdown
            },{
                title: FORM_BUSINESS_PAGE_TEXTS.titles.CELL_PHONE_NUMBER,
                subTitle: FORM_BUSINESS_PAGE_TEXTS.titles.BUSINESS_PHONE_SUB_HEADER,
                inputPlaceHolder: FORM_BUSINESS_PAGE_TEXTS.placeHolders.CELL_PHONE_NUMBER,
                inputType: InputTypes.phoneNumber,
                propName: FORM_BUSINESS_PAGE_TEXTS.propertyNames.CELL_PHONE_NUMBER
            },{
                title: FORM_BUSINESS_PAGE_TEXTS.titles.ADDRESS,
                inputPlaceHolder: FORM_BUSINESS_PAGE_TEXTS.placeHolders.ADDRESS,
                inputType: InputTypes.locationSearch,
                propName: FORM_BUSINESS_PAGE_TEXTS.propertyNames.ADDRESS
            })
        }
        return businessSteps;
    };

    private trackAnalytics = () => {
        const {store} = this.props;
        GoogleAnalyticsService.triggerEvent("signup", "form submission", "business details");
        MixPanelAnalyticsService.track(AnalyticsSignUpEvents.FullBusinessDetails, store.formInput.business);
        FBPixelService.track(`${store.formInput.plans.plansValue} Lead created`);
    };

    private getEmailErrorMessage = () => {
        const {store} = this.props;
        if(!store.formInput[storePropertyName]) {
            return null;
        }
        if(!store.isEmailValid) {
            return <div> This email is already in use. Please<a className="link" href={"https://app.salaryo.com/login"}> log in </a> </div>;
        }
        if(!FormUtils.validateEmailChars(store.formInput[storePropertyName][FORM_BUSINESS_PAGE_TEXTS.propertyNames.EMAIL_ADDRESS])) {
            return <div> Please enter a valid email address </div>;
        }
        return null
    };

    // private renderCreateUserErrorIfNeeded = () => {
    //     const {store} = this.props;
    //     if(!store.isEmailValid) {
    //         return (<div className={"error-text"}>Whoops! there was an error in the registration, please refresh or try later</div>)
    //     }
    //     return null;
    // };

    private renderLoginLinkIfNeeded = () => {
        if(this.props.location.pathname === NavigationConstants.businessLoan) {
            return <div className={"login-link"}> <a href={FormUtils.getLoginLink()}>Salaryo member? Log in</a></div>
        }
        return null
    };

    private generateCompanyTypes = () => {
        return Object.keys(ESBABusinessType).map((key) => ({value: ESBABusinessType[key], label: ESBABusinessType[key]}));
    };

    private updateSelectedBusinessType = (value: string) => {
        const {store} = this.props;
        store.formInput.business.businessType = value;
    };
}




// WEBPACK FOOTER //
// ./src/scenes/Forms/screens/SignUpForm/FormBusiness/FormBusiness.tsx